export default __webpack_public_path__ + "static/media/polygon2.2cbdf1ae.png";